

import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpService } from './http.service';
import { HttpHeaders } from '@angular/common/http';
import { HospitalSettings } from '../../../interfaces/masters/hospitalsettings';

@Injectable()
export class HospitalSettingsApi {
  //private readonly apiController: string = 'tenants/';

  constructor(private api: HttpService) { }

  list(url: string, options?: any): Observable<any[]> {
    const header = new HttpHeaders({"Accept":"application/vnd.ezovion.hateoas+json"});
  
    return this.api.directGet(url,{headers:{"Accept":"application/vnd.ezovion.hateoas+json"}});
  }
  roomrentlist(url: string, options?: any): Observable<any> {
    const header = new HttpHeaders({"Accept":"application/vnd.ezovion.hateoas+json"});
    //header.append('Content-Type', 'applications/json');
    //headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    //header.append('Accept','application/vnd.ezovion.hateoas+json');
    return this.api.get(url,{headers:{"Accept":"application/vnd.ezovion.hateoas+json"}});
  }

  getById(url: string, options?: any): Observable<HospitalSettings> {
    let header = new HttpHeaders();
    header.append('Content-Type', 'applications/json');
    header.append('Accept','application/vnd.ezovion.hateoas+json');
    return this.api.directGet(url,header);
  }

  add(url:string, data: HospitalSettings):Observable<HospitalSettings>{
    console.log('data2',data);
    let header = new HttpHeaders();
    header.append('Content-Type', 'applications/json');
    header.append('Accept','application/vnd.ezovion.hateoas+json');
    return this.api.directPost(url, data, header);
  }

  update(url:string, data: HospitalSettings):Observable<any>{
    let header = new HttpHeaders();
    header.append('Content-Type', 'applications/json');
    header.append('Accept','application/vnd.ezovion.hateoas+json');
    return this.api.directPut( url, data, header);
  }

  delete(url: string):Observable<any>{
    return this.api.directDelete(url);
  }
}
